/* The House of Others — homepage behaviour (tabs, row arrows, testimonials, mobile menu). */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Tabs ---------------------------------------------------------------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hoo-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-hoo-panel]'));
    if (!tabs.length) return;

    function select(index, focus) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (panels[i]) panels[i].hidden = !on;
      });
      if (focus) tabs[index].focus();
      var scroller = panels[index] && panels[index].querySelector('[data-hoo-scroll]');
      if (scroller) scroller.dispatchEvent(new Event('scroll'));
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });
      tab.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (e.key === 'Home') { e.preventDefault(); select(0, true); }
        else if (e.key === 'End') { e.preventDefault(); select(tabs.length - 1, true); }
        else if (dir) { e.preventDefault(); select((i + dir + tabs.length) % tabs.length, true); }
      });
    });
  }

  /* Product rows: arrow buttons follow scroll position ------------------- */
  function initRow(row) {
    var scroller = row.querySelector('[data-hoo-scroll]');
    var prev = row.querySelector('[data-hoo-prev]');
    var next = row.querySelector('[data-hoo-next]');
    if (!scroller || !prev || !next) return;

    function step() {
      var card = scroller.querySelector('.hoo-card');
      if (!card) return scroller.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(scroller).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth - 2;
      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= max;
    }

    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    function behavior() { return calm.matches ? 'auto' : 'smooth'; }
    prev.addEventListener('click', function () { scroller.scrollBy({ left: -step(), behavior: behavior() }); });
    next.addEventListener('click', function () { scroller.scrollBy({ left: step(), behavior: behavior() }); });
    /* keep a tabbed-to card fully in view */
    scroller.addEventListener('focusin', function (e) {
      var card = e.target.closest && e.target.closest('.hoo-card');
      if (card) card.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'auto' });
    });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Testimonials start scrolled so the cards peek in from both edges ------ */
  function initTesti(scroller) {
    var first = scroller.firstElementChild;
    if (!first || window.matchMedia('(max-width: 767.98px)').matches) return;
    var u = scroller.getBoundingClientRect().width / 1366;
    scroller.scrollLeft = 253.1 * u;
  }

  /* Mobile menu ---------------------------------------------------------- */
  function initBurger(header) {
    var burger = header.querySelector('[data-hoo-burger]');
    var drawer = header.querySelector('.hoo-drawer, .hoo-pb__drawer');
    if (!burger || !drawer) return;

    function toggle(open) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? (burger.getAttribute('data-label-close') || 'Close menu') : (burger.getAttribute('data-label-open') || 'Open menu'));
      drawer.hidden = !open;
    }

    burger.addEventListener('click', function () { toggle(drawer.hidden); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) { toggle(false); burger.focus(); }
    });
    if (!header.hasAttribute('data-hoo-pagebar')) {
      window.matchMedia('(min-width: 768px)').addEventListener('change', function (e) {
        if (e.matches) toggle(false);
      });
    }
  }

  /* cart count in the accessible name of the cart button */
  function initCartLabel() {
    document.querySelectorAll('.hoo-act--cart, .hoo-pb__cart').forEach(function (btn) {
      function update() {
        var c = btn.querySelector('.cart-bubble__text-count');
        var n = c ? parseInt(c.textContent, 10) : 0;
        btn.setAttribute('aria-label', n > 0 ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart');
      }
      update();
      var c = btn.querySelector('.cart-bubble__text-count');
      if (c && window.MutationObserver) new MutationObserver(update).observe(c, { childList: true, characterData: true, subtree: true });
    });
  }

  /* Entrance animations, measured from the published Canva site (same on desktop and phone):
     Rise = fade + 80px up, Pan = fade + 80px in from the left, Fade, all 500ms ease-out;
     Breathe = 4s scale .9 > 1.03 > 1. [selector, effect, offset in ms].
     Offsets reproduce the sequence Canva plays together (values 0/200/400, tabs 600/800 ...);
     elements revealed later (scrolled into view) keep their spacing relative to each other. */
  var REVEAL = [
    ['.hoo-values__col:nth-child(1) > *', 'rise', 0],
    ['.hoo-values__col:nth-child(2) > *', 'rise', 200],
    ['.hoo-values__col:nth-child(3) > *', 'rise', 400],
    ['.hoo-tabs__bar .hoo-tab:nth-child(1)', 'pan', 600],
    ['.hoo-tabs__bar .hoo-tab:nth-child(2)', 'pan', 800],
    ['.hoo-shopall .hoo-btn__bg', 'breathe', 0],
    ['.hoo-shopall__text', 'breathe', 0],
    ['.hoo-mission__photo', 'pan', 0],
    ['.hoo-mission__spark', 'fade', 400],
    ['.hoo-mission__text', 'fade', 400],
    ['.hoo-prodrow__spark', 'fade', 0],
    ['.hoo-prodrow__icon', 'fade', 200],
    ['.hoo-prodrow__title', 'fade', 400],
    ['.hoo-testi__burst', 'rise', 0],
    ['.hoo-testi__title', 'rise', 200]
  ];
  var revealIO = null;
  var wave = { base: 0, t0: -1e9, end: -1e9 };

  /* Announcement: the published Canva site fades the words in from right to left
     (50ms apart, 200ms ease-out each) while each drifts ~14px left (1s ease-out). Plays once. */
  function initMerge() {
    var root = document.documentElement;
    if (!root.classList.contains('hoo-js') || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('.hoo-ann__text').forEach(function (p) {
      if (p.hasAttribute('data-hoo-merge') || p.__hooMerging) return;
      p.__hooMerging = true;
      var host = p.querySelector('a') || p;
      var text = host.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return;

      function split() {
        var probe = document.createElement('span');
        probe.textContent = text;
        host.textContent = '';
        host.appendChild(probe);
        var plain = probe.getBoundingClientRect().width;

        var sr = document.createElement('span');
        sr.className = 'hoo-sr';
        sr.textContent = text;
        var vis = document.createElement('span');
        vis.className = 'hoo-merge hoo-merge--init';
        vis.setAttribute('aria-hidden', 'true');
        var words = text.split(' ');
        words.forEach(function (word, i) {
          var s = document.createElement('span');
          s.className = 'hoo-merge__w';
          s.textContent = word;
          s.style.setProperty('--d', (words.length - 1 - i) * 50 + 'ms');
          vis.appendChild(s);
          if (i < words.length - 1) vis.appendChild(document.createTextNode(' '));
        });
        host.textContent = '';
        host.appendChild(sr);
        host.appendChild(vis);
        var now = vis.getBoundingClientRect().width;
        if (plain && now && Math.abs(now - plain) > 0.2) vis.style.letterSpacing = (plain - now) / text.length + 'px';

        p.setAttribute('data-hoo-merge', '');
        /* settle into the hidden state with transitions off, then re-enable them so the
           first reveal really animates */
        void p.offsetWidth;
        vis.classList.remove('hoo-merge--init');
        void p.offsetWidth;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { p.classList.add('is-in'); io.disconnect(); }
          });
        }, { threshold: 0.6 });
        requestAnimationFrame(function () { io.observe(p); });
      }

      var done = false;
      function go() { if (!done) { done = true; split(); } }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(go);
      setTimeout(go, 1200);
    });
  }

  function initReveal() {
    var root = document.documentElement;
    if (!root.classList.contains('hoo-js') || !('IntersectionObserver' in window)) return;
    if (revealIO) revealIO.disconnect();
    root.classList.add('hoo-rv-init'); /* tag without transitions so nothing blends from its visible state */
    var items = [];
    REVEAL.forEach(function (r) {
      document.querySelectorAll(r[0]).forEach(function (el) {
        if (el.hasAttribute('data-hoo-rv')) return;
        el.setAttribute('data-hoo-rv', r[1]);
        el.__hooOff = r[2];
        items.push(el);
      });
    });
    var io = revealIO = new IntersectionObserver(function (entries) {
      var vis = entries.filter(function (e) { return e.isIntersecting; })
        .sort(function (a, b) { return a.target.__hooOff - b.target.__hooOff; });
      if (!vis.length) return;
      var now = performance.now();
      /* a new wave starts when nothing is still playing */
      if (now > wave.end + 300) { wave.base = vis[0].target.__hooOff; wave.t0 = now; wave.end = now; }
      vis.forEach(function (e) {
        var delay = Math.max(0, (e.target.__hooOff - wave.base) - (now - wave.t0));
        wave.end = Math.max(wave.end, now + delay + 500);
        e.target.style.setProperty('--hoo-d', delay + 'ms');
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 100px -6% 100px', threshold: 0.05 });
    void document.body.offsetHeight; /* commit the hidden state before observing */
    root.classList.remove('hoo-rv-init');
    void document.body.offsetHeight;
    requestAnimationFrame(function () { items.forEach(function (el) { io.observe(el); }); });
  }

  /* FAQs page: open the question named in the URL hash */
  function initFaqPage(root) {
    function openHash() {
      var id = decodeURIComponent((location.hash || '').slice(1));
      if (!id) return;
      var el = document.getElementById(id);
      if (el && el.matches && el.matches('details')) { el.open = true; el.scrollIntoView({ block: 'start' }); }
    }
    openHash();
    window.addEventListener('hashchange', openHash);
  }

  /* Product page: when "Add to cart" is pressed with an option still unchosen, flag that option */
  function initNeedSize() {
    function flag() {
      document.querySelectorAll('variant-picker .variant-option').forEach(function (group) {
        var radios = group.querySelectorAll('input[type=radio]');
        if (!radios.length || group.querySelector('input[type=radio]:checked')) return;
        group.classList.add('hoo-need');
        var r = group.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) group.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(function () { group.classList.remove('hoo-need'); }, 1800);
      });
    }
    /* the theme marks the form (data-bmp-size-missing) when an option is missing; react to that */
    if (window.MutationObserver && document.querySelector('variant-picker')) {
      var last = 0;
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          var t = m.target;
          if (t.getAttribute && t.getAttribute('data-bmp-size-missing') !== null && t.getAttribute('data-bmp-size-missing') !== 'false' && Date.now() - last > 2000) {
            last = Date.now();
            flag();
          }
        });
      }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['data-bmp-size-missing'] });
    }
  }

  /* Product gallery. The visible colour's photo loads first; the other colours' photos are held back
     (data-hoo-src / data-hoo-srcset, see snippets/product-media.liquid) so they cannot compete with it.
     Once that photo has loaded they are released one by one in the background, and the one a shopper
     reaches for (hover / tap / focus on a colour, thumbnail or arrow) is released immediately. */
  function initGallery() {
    var gal = document.querySelector('media-gallery');
    if (!gal || gal.__hooWarm) return;
    gal.__hooWarm = true;

    /* the slide scroller scrolls with the arrow keys once focusable (keyboard users otherwise rely on the thumbnails) */
    var scroller = gal.querySelector('slideshow-slides');
    if (scroller && scroller.scrollWidth > scroller.clientWidth + 2) {
      scroller.setAttribute('tabindex', '0');
      scroller.setAttribute('role', 'group');
      scroller.setAttribute('aria-label', 'Product photos');
    }

    function held() { return Array.prototype.slice.call(gal.querySelectorAll('img[data-hoo-srcset], img[data-hoo-src]')); }
    function release(img, urgent) {
      if (!img || !(img.hasAttribute('data-hoo-srcset') || img.hasAttribute('data-hoo-src'))) return;
      if (urgent) img.setAttribute('fetchpriority', 'high');
      var ss = img.getAttribute('data-hoo-srcset'), s = img.getAttribute('data-hoo-src');
      img.removeAttribute('data-hoo-srcset'); img.removeAttribute('data-hoo-src');
      if (ss) img.setAttribute('srcset', ss);
      if (s) img.setAttribute('src', s);
    }
    function slideImg(mediaId) { return gal.querySelector('.product-media[data-media-id="' + mediaId + '"] img'); }

    /* colour -> photo, from the product's own data (small, fetched once, after the page settled) */
    var variantMedia = null;
    function loadMap() {
      if (variantMedia) return;
      variantMedia = {};
      fetch(location.pathname.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (p) { (p.variants || []).forEach(function (v) { if (v.featured_media) variantMedia[v.id] = v.featured_media.id; }); })
        .catch(function () {});
    }

    /* intent: release the photo for whatever the shopper is reaching for */
    function reach(e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var input = t.closest('variant-picker label') && t.closest('variant-picker label').querySelector('input[data-variant-id]');
      if (input && variantMedia) {
        var m = variantMedia[input.getAttribute('data-variant-id')];
        if (m) { release(slideImg(m), true); return; }
      }
      var thumb = t.closest('.slideshow-controls__thumbnails button');
      if (thumb) {
        var idx = Array.prototype.indexOf.call(thumb.parentElement.children, thumb);
        var slides = gal.querySelectorAll('slideshow-slide .product-media img');
        if (slides[idx]) release(slides[idx], true);
        return;
      }
      if (t.closest('.slideshow-control--previous, .slideshow-control--next, slideshow-arrows')) held().slice(0, 2).forEach(function (i) { release(i, true); });
    }
    ['pointerenter', 'pointerdown', 'touchstart', 'focusin'].forEach(function (ev) {
      document.addEventListener(ev, reach, { capture: true, passive: true });
    });

    /* ---- instant colour swap ----
       The theme answers a colour click by re-downloading the whole product page and then rebuilding the gallery
       from it, so the photo only changes after a ~500KB round trip. Everything needed is already on the page:
       select the colour's photo right away (showing its thumbnail while the full image arrives) and keep the
       existing gallery when the rebuilt one would hold the same photos. */
    function mediaIds(root) {
      return Array.prototype.map.call(root.querySelectorAll('slideshow-slide .product-media'), function (m) { return m.getAttribute('data-media-id'); }).sort().join(',');
    }
    var origReplace = gal.replaceWith.bind(gal);
    gal.replaceWith = function (next) {
      if (next && next.querySelectorAll && mediaIds(next) && mediaIds(next) === mediaIds(gal)) return;
      return origReplace(next);
    };
    function showColour(variantId) {
      var media = variantMedia && variantMedia[variantId];
      if (!media || !gal.isConnected) return;
      var slides = gal.querySelectorAll('slideshow-slide .product-media');
      var idx = -1;
      for (var k = 0; k < slides.length; k++) if (slides[k].getAttribute('data-media-id') === String(media)) { idx = k; break; }
      if (idx < 0) return;
      var img = slides[idx].querySelector('img');
      release(img, true);
      if (img && !img.complete) {
        var thumbs = gal.querySelectorAll('.slideshow-controls__thumbnails button img');
        var t = thumbs[idx];
        if (t && t.currentSrc) {
          img.style.background = 'center / cover no-repeat url("' + t.currentSrc + '")';
          img.addEventListener('load', function () { img.style.background = ''; }, { once: true });
        }
      }
      try { if (gal.slideshow) gal.slideshow.select(idx, undefined, { animate: false }); } catch (err) {}
    }
    document.addEventListener('change', function (e) {
      var inp = e.target;
      if (!inp || !inp.matches || !inp.matches('variant-picker input[type=radio]')) return;
      if ((inp.getAttribute('data-option-name') || '').toLowerCase() !== 'color') return;
      showColour(inp.getAttribute('data-variant-id'));
    }, true);

    var conn = navigator.connection || {};
    var polite = !(conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '') || (conn.type === 'cellular' && conn.effectiveType && conn.effectiveType !== '4g'));

    function stream() {
      loadMap();
      if (!polite) return;
      var queue = held();
      (function next() {
        var img = queue.shift();
        if (!img) return;
        release(img, false);
        setTimeout(next, 90);
      })();
    }
    function start() {
      var main = gal.querySelector('img:not([data-hoo-src]):not([data-hoo-srcset])');
      var go = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 400); })(stream, { timeout: 3000 }); };
      if (document.readyState !== 'complete') { window.addEventListener('load', function () { setTimeout(go, 300); }); return; }
      if (main && !main.complete) main.addEventListener('load', go, { once: true }); else go();
    }
    loadMap();
    start();
  }

  function init() {
    initMerge();
    initGallery();
    if (!window.__hooNeed) { window.__hooNeed = true; initNeedSize(); }
    initReveal();
    initCartLabel();
    document.querySelectorAll('[data-hoo-fp]').forEach(initFaqPage);
    document.querySelectorAll('[data-hoo-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-hoo-row]').forEach(initRow);
    document.querySelectorAll('[data-hoo-testi]').forEach(initTesti);
    window.matchMedia('(min-width: 768px)').addEventListener('change', function () { document.querySelectorAll('[data-hoo-testi]').forEach(initTesti); });
    document.querySelectorAll('[data-hoo-header]').forEach(initBurger);
  }

  window.__hooReady = true;
  ready(init);
  /* theme editor re-renders sections in place */
  document.addEventListener('shopify:section:load', init);
})();
